import { Injectable, Injector } from '@angular/core';
import { Location } from '@angular/common';
import { AbstractNavigator } from '@auth0/auth0-angular';

/**
 * Custom Auth0 navigator that replaces the SDK's automatic post-callback
 * router navigation with a silent URL cleanup via Location.replaceState.
 *
 * Without this, the SDK calls router.navigateByUrl('/') after processing
 * the authorization code, which triggers the redirectTo: '/login' route rule
 * and causes a brief flash of the login page before the callback component
 * finishes its own redirect.
 *
 * Using replaceState instead of a no-op is critical: if the ?code= and
 * ?state= params remain in the URL, auth0-spa-js treats the session as
 * unauthenticated when isAuthenticated() is subsequently called, causing
 * the observable chain in AuthCallbackComponent to hang or error.
 */
@Injectable({
  providedIn: 'root'
})
export class Auth0NavigatorService extends AbstractNavigator {
  private readonly ownLocation: Location;

  constructor(location: Location, injector: Injector) {
    super(location, injector);
    this.ownLocation = location;
  }

  override navigateByUrl(url: string): void {
    if (window.location.pathname === '/callback') {
      // Silently update the browser URL (removes ?code=&state= params)
      // without triggering Angular router navigation.
      this.ownLocation.replaceState(url);
      return;
    }
    super.navigateByUrl(url);
  }
}

